import React, { useState, useContext, createContext } from 'react'

const passwordContext = createContext({
    password: '',
    setPassword: () => {},
    clearPassword: () => {},
})

export function ProvidePassword({ children }) {
    const password = useProvidePassword()
    return (
        <passwordContext.Provider value={password}>
            {children}
        </passwordContext.Provider>
    )
}

function useProvidePassword() {
    const [password, setPassword] = useState('')

    const clearPassword = () => {
        setPassword('')
    }

    return {
        password,
        setPassword,
        clearPassword,
    }
}

export const usePassword = () => {
    return useContext(passwordContext)
}

